<script>
	import { onMount } from 'svelte';
	import { documentos, cuenta, recetaActiva } from './../controlador/store.js';
	import ItemPlantilla from './../componentes/itemPlantilla.svelte';
    import UserController from "../controlador/userController.svelte";
import { beforeUpdate } from 'svelte';
    let control;
    let lista = [];
    async function click(){
        control.actualizarCuenta('demo','doctor','asdjkl','firma');
	}
	onMount(()=>{
		$recetaActiva = {documento:"",nombre:"",mutual:"",afiliado:"",cuerpo:""};
	})
	beforeUpdate(()=>{
		lista = $documentos.filter((el)=>el._id.includes(`plantillas:${$cuenta.user}`));
	})
</script>
<UserController bind:this={control} />
<div class="container scroll"><!-- este es el q puede scrolear en todos-->
	<h2>Plantillas</h2>
	<a href="#/nueva/plantilla" class="boton">Nueva Plantilla</a>
	{#each lista as t}
		<ItemPlantilla plantilla={t} />
	{/each}
	<a href="#/nueva/receta" class="flotante"><i class="ph-plus"></i></a>
</div>

<style>
	h2{
		color: white;
		width: 100%;
		padding: 10px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.scroll {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;
		overflow-y: scroll;
	}
	.boton{
		background: transparent;
		border: none;
		outline: none;
		cursor: pointer;
		color: white;
		margin: 10px;
		padding: 5px;
		text-decoration: none;
	}
	.flotante{
		position: fixed;
		bottom: 20px;
		right: 20px;
		width: 50px;
		height: 50px;
		border-radius: 25px;
		background:linear-gradient(135deg, rgba(255,255,255,1) 0%, rgba(207,215,255,1) 100%);
		border:none;
		outline: none;
		color: var(--azul);
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 30px;
		cursor: pointer;
		text-decoration: none;
		z-index: 200;
	}
	.flotante > i{
		margin-top: 5px;
	}
</style>